import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import * as Constants from "../../utilities/Constants";
import SetEmailForm from "./SetEmailForm";
import SetEmailInfo from "./SetEmailInfo";
import CheckPasswordOnLinkToVirtualUser from "./CheckPasswordOnLinkToVirtualUser";
import { isEnterPressed } from "../../utilities/EventsHelper";
import UrlHelper from "../../utilities/UrlHelper";

export class SetEmailPage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            email: ""
        };

        this.sendEmail = this.sendEmail.bind(this);
        this.onEmailChanged = this.onEmailChanged.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
    }

    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.sendEmail();
        }
    }

    onEmailChanged (email) {
        this.setState({ email: email });
    }

    sendEmail () {
        if (this.props.isUpgradeToVirtualUser)
            this.props.startUpgradeToVirtualUser(this.state.email);
        else
            this.props.sendVerifyEmail(this.state.email);
    }

    render () {
        const skipUrl = UrlHelper.getParameterByName("skipUrl");
        const email = this.state.email;

        const redirectLocation = this.props.redirectLocation;
        if (redirectLocation) {
            window.location = redirectLocation;
        }

        if (this.props.step === Constants.linkEmailSteps.first) {
            return (<SetEmailForm sendEmail={this.sendEmail}
                skipUrl={skipUrl}
                email={email}
                onEmailChanged={this.onEmailChanged}
                hideSkipLink={!skipUrl}
            />);
        }

        if (this.props.step === Constants.linkEmailSteps.second) {
            return (<SetEmailInfo email={email} changeEmail={this.props.changeEmail}
                sendEmail={this.sendEmail}
                skipUrl={skipUrl}/>);
        }

        if (this.props.step === Constants.linkEmailSteps.enterPassword) {
            return <CheckPasswordOnLinkToVirtualUser email={email} />;
        }

        return null;
    }
}

SetEmailPage.defaultProps = {
    step: Constants.linkEmailSteps.first
};

SetEmailPage.propTypes = {
    isUpgradeToVirtualUser: PropTypes.bool.isRequired,
    sendVerifyEmail: PropTypes.func,
    startUpgradeToVirtualUser: PropTypes.func,
    changeEmail: PropTypes.func,
    step: PropTypes.string,
    redirectLocation: PropTypes.string
};

const mapStateToProps = state => ({
    step: state.emailLoginState.step,
    redirectLocation: state.emailLoginState.redirectLocation,
});

const mapDispatchToProps = (dispatch) => {
    return ({
        sendVerifyEmail: (email) => dispatch(actions.sendVerifyEmail(window.CurrentVirtualUserId, email)),
        startUpgradeToVirtualUser: (email) => dispatch(actions.startUpgradeToVirtualUser(email)),
        changeEmail: ()=> dispatch(actions.goToTheFirstLinkingEmailStep()),
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(SetEmailPage);
